module.exports = __webpack_public_path__ + "img/padlock.efcc48d2.svg";